import { render, staticRenderFns } from "./AppSidebarViewControl.vue?vue&type=template&id=35e16753&scoped=true&lang=pug"
import script from "./AppSidebarViewControl.vue?vue&type=script&lang=ts"
export * from "./AppSidebarViewControl.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebarViewControl.vue?vue&type=style&index=0&id=35e16753&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e16753",
  null
  
)

export default component.exports